// reducers/index.ts
import { combineReducers } from 'redux';
import userReducer from './userReducer';
import leaderboardReducer from './leaderboardReducer';
import tasksReducer from './tasksReducer';
import friendsReducer from './friendsReducer';
import { RootState } from '../type';

const rootReducer = combineReducers<RootState>({
  userData: userReducer as any,
  leaderboard: leaderboardReducer as any,
  tasks: tasksReducer as any,
  friends: friendsReducer as any,
});

export default rootReducer;
